import React from 'react';
import kutubeeLogo from '../../../../../../img/kutubee-logo.png';

export const KutubeeLoginPageTemplate = ({t, children}) => {
  return (
    <div className="login-page animated fadeInDown smart-style-6">
      <div id="main" role="main">
        <div id="content" className="container">
          <h1 className="login-page__title text-hide">{t("Welcome")}</h1>
          <div className="row form-wrap">
            <img className="login-page__logo" src={kutubeeLogo} />
            <div className="form-wrap__inner">
              <div className="col-sm-offset-3 col-md-offset-4 col-sm-6 col-md-5 col-lg-4">
                <div className="well no-padding">
                  
                  { children }
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
